// oxlint-disable qdrant/route-id-matches-path
import { rootRouteId, useRouteContext } from '@tanstack/react-router';
import { type AuthContext } from '@/helpers/auth';

/*
 * Token indicating that the Auth0 context is unavailable. There are two cases where it is not available:
 * 1. Before the authentication SDK is loaded and its API passed down via Router context.
 * 2. Below authenticated routes, where the context is intentionally not provided to prevent misuse. In this case, use `useAuthenticatedUserClaims` instead.
 */
export const UnavailableAuth0Context = Symbol('UnavailableAuth0Context');

/**
 * Returns the current authentication context from the router state.
 * Throws if used below authenticated routes where the context is intentionally not provided to prevent misuse.
 * In this case, use `useAuthenticatedUserClaims` instead.
 */
export const useAuth0Context = (): AuthContext => {
  const { auth } = useRouteContext({ from: rootRouteId });
  if (auth === UnavailableAuth0Context) {
    throw new Error(
      'Auth0 context is not available below authenticated routes. Use `useAuthenticatedUserClaims` instead.',
    );
  }
  return auth;
};
